/** The thread composer's saved, unsent reply: read once per thread, saved/discarded on demand. A draft is not a fact, so nothing else is invalidated. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { campaignKeys } from '../queryKeys';
import { deleteComposerDraft, fetchComposerDraft, saveComposerDraft, type OutreachComposerDraft, type OutreachComposerDraftInput } from '../api/outreachComposerDraftApi';

export function useOutreachComposerDraft(entryId: string, enabled = true) {
  const qc = useQueryClient();
  const key = campaignKeys.outreachComposerDraft(entryId);

  const draft = useQuery<OutreachComposerDraft | null>({
    queryKey: key,
    queryFn: () => fetchComposerDraft(entryId),
    enabled: enabled && !!entryId,
  });

  const save = useMutation<OutreachComposerDraft, Error, OutreachComposerDraftInput>({
    mutationFn: (input) => saveComposerDraft(entryId, input),
    onSuccess: (saved) => qc.setQueryData(key, saved),
  });

  const discard = useMutation<void, Error, void>({
    mutationFn: () => deleteComposerDraft(entryId),
    onSuccess: () => qc.setQueryData(key, null),
  });

  return { draft, save, discard };
}
